<div class="form-wrapper" [ngClass]="{'no-padding': isInCheckout()}">
    <cwo-address-form #addressFormComp 
        [address]="address()" 
        [editing]="isSavedAddress()" 
        [isInAddressEditingMode]="isSavedAddress()" 
        [orderType]="orderType()"
        [allErrors]="allErrors"
        [validationResponse]="validationResponse"
        (formChanging)="handleFormChanging()"
        (overrideAddress)="handleOverrideAddress()"
        (noThankYou)="handleNoThankyou()"
        (deliveryInstructionExpanded)="handleDeliveryInstructionExpanded($event)"    
    />
</div>
@if(!hideDone()){
<div class="done-button-wrapper">
    <button cwoAsyncButton [subscription]="loadingSubscription" class="button-accent done-button" (click)="done()">{{'shared_components.edit_address.done' | transloco}}</button>
</div>
}